import { Box, IconButton } from '@mui/material';
import { useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { NotificationWithTime } from '../../utils/groupNotificationsByDate';
import { homePageService } from '../../utils/services/homePageService';
import { notificationBadge, notificationButton } from 'app/widgets/header/ui/Header.sx';
import BellIcon from '../Icons/BellIcon';
import NotificationBar from 'app/widgets/notification-bar';

const NotificationLayer = (props: { isDisabled: boolean }) => {
  const notificationIconRef = useRef<HTMLButtonElement>(null);
  const [openNotifications, setOpenNotifications] = useState(false);
  const { data: notifications } = useQuery(['notifications'], () =>
    homePageService.getNotifications()
  );
  const unReadNotificationsCount = notifications?.reduce((acc, item) => {
    return (
      acc +
      item?.items?.filter((notification: NotificationWithTime) => notification?.read === 'unread')
        ?.length
    );
  }, 0);

  return (
    <>
      <IconButton
        disabled={props.isDisabled}
        ref={notificationIconRef}
        onClick={() => setOpenNotifications(prev => !prev)}
        sx={notificationButton}
        disableRipple
      >
        <BellIcon />
        {!!unReadNotificationsCount && <Box sx={notificationBadge} />}
      </IconButton>
      <NotificationBar
        notificationIconRef={notificationIconRef}
        open={openNotifications}
        onClose={() => setOpenNotifications(false)}
      />
    </>
  );
};

export default NotificationLayer;
